/* eslint-disable @typescript-eslint/no-unused-vars */
import { View, Text as PDFText, Image } from '@react-pdf/renderer'

import styles from './styles/index.style'

interface HeaderProps {
  Created: string
  ReservationNumber: string
}

const Header = ({ ReservationNumber, Created }: HeaderProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.rowDirection}>
        <PDFText style={styles.subjectTitle}>CRS Resevation No: </PDFText>
        <PDFText style={styles.subjectValue}>{ReservationNumber}</PDFText>
      </View>
      <View style={styles.rowDirection}>
        <PDFText style={styles.subjectTitle}>Reserve Time: </PDFText>
        <PDFText style={styles.subjectValue}>{Created}</PDFText>
      </View>
    </View>
  )
}
export default Header
